<template>
  <a-config-provider :locale="locale">
    <div id="app">
      <!-- <keep-alive exclude="shell,Detail,Home,LoginIndex"> -->
      <router-view />
      <!-- </keep-alive> -->
    </div>
  </a-config-provider>
</template>

<script>
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
import common from "@/common/js/common.js";
export default {
  name: 'App',
  data() {
    return {
      locale: zhCN
    }
  },

  created() {
    if (this.$route.name !== 'myPersonalStudyFee' && localStorage.getItem('token')) {
      if (this.$route.path === "/quick/login" || this.$route.path === '/teach/net' || this.$route.path === "/login") {
         return
      }
      this.axios.get('/sys/login/userinfo').then(res => {
        let userInfo = res.result.userInfo
        userInfo.eduLogo = res.result.eduLogo || null
        userInfo.headTitle = res.result.headTitle
        userInfo.pageTitle = res.result.pageTitle
        document.title = `${userInfo.eduName} - ${userInfo.pageTitle}`
        this.common.setStorage('userInfo', userInfo)
        this.$store.commit('SET_USERINFO', userInfo)
        this.initKefuUser(userInfo)
        // if(localStorage.getItem('isNeedAuth')){
        //   common.info()
        // }
        console.log('userInfo App')
      })
    }

    if (localStorage.getItem('isLoginByInter') !== '1') {
      (function () {
        var s = document.createElement('script')
        s.src = 'https://kefu.jxjypt.cn/sdk/kefu-sdk.js'
        s.dataset.appId = 'jxjypt_cn'
        s.dataset.baseUrl = 'https://kefu.jxjypt.cn' // 宿主页与客服服务不同源，必须显式指定
        document.head.appendChild(s)
      })()
    }
  },
  methods: {
    // kefu 客服 SDK 异步挂载，轮询就绪后传入登录学生身份（未登录时 SDK 按匿名访客运行）
    initKefuUser(userInfo) {
      if (!userInfo || !userInfo.id) return
      var tries = 100
      var timer = setInterval(() => {
        if (window.KefuSDK) {
          clearInterval(timer)
          window.KefuSDK.setUser({ userId: String(userInfo.id), userName: userInfo.name })
        } else if (--tries <= 0) {
          clearInterval(timer)
        }
      }, 100)
    }
  }
}
</script>

<style>
body {
  font-size: 15px;
}

.ellipsis {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}

.ellipsis-2 {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}

/* 全局消息提示容器 - 固定在顶部中央 */
.ant-message {
  position: fixed;
  top: 50px;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  pointer-events: none; /* 防止阻挡下方元素交互 */
  z-index: 1010; /* 确保在大多数内容之上 */
}

/* 单个消息通知容器 */
.ant-message-notice {
  margin-bottom: 8px; /* 消息间距 */
  transition: all 0.3s ease; /* 平滑动画 */
}

/* 消息内容主体 */
.ant-message-notice-content {
  /* min-width: 200px; */ /* 最小宽度 */
  /* max-width: 80%; */ /* 最大宽度 */
  padding: 10px 16px;
  border-radius: 4px;
  box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 
              0 6px 16px 0 rgba(0, 0, 0, 0.08),
              0 9px 28px 8px rgba(0, 0, 0, 0.05); /* 优雅阴影 */
  background: #fff;
  display: inline-flex;
  align-items: center;
  pointer-events: auto; /* 恢复交互 */
}

/* 消息内容区域 */
.ant-message-custom-content {
  display: flex;
  align-items: center;
  font-size: 14px;
  line-height: 1.5;
}

/* 不同类型消息的颜色方案 */
.ant-message-success .ant-message-notice-content {
  background-color: #f6ffed;
  border: 1px solid #b7eb8f;
  color: #52c41a;
}

.ant-message-error .ant-message-notice-content {
  background-color: #fff1f0;
  border: 1px solid #ffa39e;
  color: #f5222d;
}

.ant-message-warning .ant-message-notice-content {
  background-color: #fffbe6;
  border: 1px solid #ffe58f;
  color: #faad14;
}

.ant-message-info .ant-message-notice-content {
  background-color: #e6f7ff;
  border: 1px solid #91d5ff;
  color: #1890ff;
}

/* 图标样式 */
.ant-message-custom-content .anticon {
  margin-right: 8px;
  margin-right: 8px;
  font-size: 16px;
}



</style>



// WEBPACK FOOTER //
// src/App.vue